//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PediatricTraumaScore',
  data () {
    return {
      defaultJson: {
        'Cutaneous Wounds': '开放性伤口',
        'Cutaneous Wounds (short)': '开放性伤口',
        'More than 20 kg': '大于 20 kg',
        'Central Nervous System': '中枢神经系统',
        'More than 90 mmHg': '大于 90 mmHg',
        '50 to 90 mmHg': '50 - 90 mmHg',
        '10 - 20 kg': '10 - 20 kg',
        'Airways': '气道',
        'Airways (short)': '气道',
        'NoneCUTANEOUS': '无',
        'Awake': '清醒',
        '> 90 mmHg (short)': '> 90 mmHg',
        'CNS (short)': '中枢神经系统',
        'Fractures': '骨创伤',
        'Normal (short)': '正常',
        'Fractures (short)': '骨创伤',
        'Unmaintainable (short)': '不可维持',
        'Maintainable': '可维持',
        'Weight (short)': '体重',
        'Minor': '小',
        'Body Weight': '体重',
        'Systolic BP (short)': '收缩压',
        '> 20 kg (short)': '> 20 kg',
        'Unmaintainable': '不可维持',
        'Less 50 mmHg': '小于 50 mmHg',
        '< 50 mmHg (short)': '< 50 mmHg',
        'Less than 10 kg': '小于 10 kg',
        '< 10 kg (short)': '< 10 kg',
        'Major': '大',
        'Maintainable (short)': '可维持',
        'NoneFRACTURE': '无',
        'Open \/ multiple': '开放性 \/ 复合性',
        'Normal': '正常',
        'Mortality': '死亡率',
        'Closed': '闭合性',
        'Obtunded': '迟钝',
        'Systolic Blood Pressure': '收缩压',
        'Coma': '昏迷'
      },
      form: {
        weight: '',
        airways: '',
        systolicBP: '',
        cns: '',
        cutaneousWound: '',
        fracture: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '-1', name: '小于 10 kg', shortName: '< 10 kg'},
        {value: '1', name: '10 - 20 kg', shortName: '10 - 20 kg'},
        {value: '2', name: '大于 20 kg', shortName: '> 20 kg'}
      ],
      dataList2: [
        {value: '-1', name: '侵入性手段（如气管插管）', shortName: '侵入性手段'},
        {value: '1', name: '需维持气道', shortName: '需维持气道'},
        {value: '2', name: '正常气道', shortName: '正常气道'}
      ],
      dataList3: [
        {value: '-1', name: '小于 50 mmHg', shortName: '< 50 mmHg'},
        {value: '1', name: '50 - 90 mmHg'},
        {value: '2', name: '大于 90 mmHg', shortName: '> 90 mmHg'}
      ],
      dataList4: [
        {value: '-1', name: '昏迷'},
        {value: '1', name: '反应迟钝'},
        {value: '2', name: '清醒'}
      ],
      dataList5: [
        {value: '-1', name: '大'},
        {value: '1', name: '小'},
        {value: '2', name: '无'}
      ],
      dataList6: [
        {value: '-1', name: '开放性骨折或多发性骨折'},
        {value: '1', name: '闭合性骨折'},
        {value: '2', name: '无骨创伤'}
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // weight + airways + systolicBP + cns + cutaneousWound + fracture
        let result = form.weight + form.airways + form.systolicBP + form.cns + form.cutaneousWound + form.fracture
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/PediatricTraumaScore.vue